import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import styles from './Checkbox.module.scss';

interface CheckboxProps {
  label: string;
  onChange: (checked: boolean) => void;
  defaultChecked?: boolean;
  containerClassName?: string;
  inputClassName?: string;
  labelClassName?: string;
  checked?: boolean;
}

export const Checkbox = ({
  label,
  onChange,
  defaultChecked,
  containerClassName,
  labelClassName,
  inputClassName,
  checked
}: CheckboxProps) => {
  const [innerCheck, setInnerCheck] = useState(defaultChecked || checked || false);

  useEffect(() => {
    if (checked !== undefined) {
      setInnerCheck(checked);
    }
  }, [checked]);

  useEffect(() => {
    if (defaultChecked !== undefined) {
      setInnerCheck(defaultChecked);
    }
  }, [defaultChecked]);

  const handleChange = () => {
    // uncontrolled checkbox
    if (checked === undefined) {
      setInnerCheck(!innerCheck);
    }

    onChange(!innerCheck);
  };

  return (
    <div className={classNames(styles.checkboxContainer, containerClassName)}>
      <input
        className={classNames(styles.checkboxInput, inputClassName)}
        checked={innerCheck}
        type="checkbox"
        readOnly
        onClick={handleChange}
      />
      <div className={classNames(styles.label, labelClassName)} onClick={handleChange}>
        {label}
      </div>
    </div>
  );
};
